var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#587E85",
    d: "M12.371 1.705c.701-.701 1.723-.975 2.68-.718.958.256 1.706 1.004 1.962 1.962.257.957-.017 1.979-.718 2.68l-11.11 11.11c-.115.115-.258.195-.414.234l-3.555.89c-.651.162-1.241-.428-1.078-1.079l.889-3.555c.039-.156.12-.3.233-.413zM17 16.11c.49 0 .889.398.889.889 0 .453-.34.827-.777.882l-.112.007H9c-.49 0-.889-.398-.889-.889 0-.453.34-.827.777-.882L9 16.111h8zM14.462 2.678c-.305-.04-.613.064-.833.284L2.692 13.897l-.471 1.881 1.881-.471L15.038 4.371c.22-.22.323-.528.284-.833l-.026-.13c-.092-.343-.36-.612-.705-.704z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.e5a6525898016de934af0e4cdf746c35.svg";
export { ForwardRef as ReactComponent };